import './App.css';
import { VoteTimeline } from './components/VoteTimeline/VoteTimeline';

function App() {
  return (
    <div className="content">
      <VoteTimeline />
    </div>
  );
}

export default App;
